import BlockSimple from './blocks/block_simple.js'
import Editor from './Editor/editor.js'
import Header from './Header/header.js'
import Modal from 'react-modal';


import './App.css';
import 'react-edit-text/dist/index.css';

import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar/sidebar.js';

import sampleBlocks from './sample.json';

let SCROLL_SCALE = 0.70
let STEP_SCALE = 0.05

function App() {
  const [blocksData, setBlocksData] = useState(
    sampleBlocks
  )

  const header_height = 64
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight - header_height);

  const [mdWidth, setMDWidth] = useState(0);
  const [mdContent, setMDContentDirect] = useState(-1);

  const setMDContent = (id) => {
      setMDContentDirect(id)
  }
  
  const [xOffset, setXOffset] = useState(0);
  const [yOffset, setYOffset] = useState(0);

  const [zoomScale, setZoomScale] = useState(0);
  
  let pct_shown = 1 * Math.pow(SCROLL_SCALE, zoomScale)


  useEffect(() => {
    const handleResize = () => {
      updateMDContent(mdContent)
      setViewportHeight(window.innerHeight - header_height);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [mdWidth]);

  
  useEffect(() => {
    const handleWheel = (event) => {

      if (event.ctrlKey){
        var zoomScaleChanged = false;
        console.log(event)

        // Track what the global % offsets the mouse is at before the scale change
        var before_x_pct = xOffset + ((event.clientX / viewportWidth) * pct_shown)
        var before_y_pct = yOffset + (((event.clientY - header_height) / (viewportHeight)) * pct_shown)

        let updated_zoom_scale = Math.max(0, zoomScale - (event.deltaY / 200))
        var  new_x_offset = xOffset
        var new_y_offset = yOffset

        if (updated_zoom_scale !== zoomScale){
          zoomScaleChanged = true
          setZoomScale(updated_zoom_scale);

          let updated_pct_shown = 1 * Math.pow(SCROLL_SCALE, updated_zoom_scale)
          new_x_offset = before_x_pct - ((event.clientX / viewportWidth) * updated_pct_shown)
          new_y_offset = before_y_pct - (((event.clientY - header_height) / (viewportHeight)) * updated_pct_shown)
        } else {
          new_x_offset = Math.max(0, xOffset - 0.03)
          new_y_offset = Math.max(0, yOffset - 0.03)
        }

        setXOffset(Math.max(new_x_offset, 0));
        setYOffset(Math.max(new_y_offset, 0));


        // Stop zoom action
        event.preventDefault();
        event.stopPropagation();
        return
      }
      
      let pct_shown_shadow = 1 * Math.pow(SCROLL_SCALE, zoomScale)
      let step_size = pct_shown_shadow * STEP_SCALE
      let max_offset = 1 - pct_shown_shadow

      const clamp = (x, delta) => {
        return Math.max(0, Math.min(max_offset, x + (step_size * Math.sign(delta))))
      }

      if (event.shiftKey){
        setXOffset(clamp(xOffset, event.deltaY));
      } else {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY) ){
          setXOffset(clamp(xOffset, event.deltaX));
        } else{
          setYOffset(clamp(yOffset, event.deltaY));
        }
      }

    };
    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, [xOffset, yOffset, zoomScale]);

  useEffect(() => {
    const handleArrow = (event) => {

      let pct_shown_shadow = 1 * Math.pow(SCROLL_SCALE, zoomScale)
      let step_size = pct_shown_shadow * STEP_SCALE
      let max_offset = 1 - pct_shown_shadow
      console.log("step size", step_size)
      switch (event.key) {
        case "ArrowLeft":
            setXOffset(Math.max(0, xOffset - step_size));
            break;
        case "ArrowRight":
            setXOffset(Math.min(max_offset, xOffset + step_size));
            break;
        case "ArrowUp":
            setYOffset(Math.max(0, yOffset - step_size));
            break;
        case "ArrowDown":
            setYOffset(Math.min(max_offset, yOffset + step_size));
            break;
        case "=":
          if (!event.ctrlKey){
            break;
          }
          var orig_x_center = xOffset + (pct_shown / 2)
          var orig_y_center = yOffset + (pct_shown / 2)
 
          setZoomScale(zoomScale + 1);

          var updated_pct_shown = 1 * Math.pow(SCROLL_SCALE, zoomScale + 1)
          var updated_x = orig_x_center - (updated_pct_shown/2)
          var updated_y = orig_y_center - (updated_pct_shown/2)
          setXOffset(Math.max(updated_x, 0))
          setYOffset(Math.max(updated_y, 0))
          
          // Stop zoom action
          event.preventDefault();
          event.stopPropagation();
          break;
        case "-":
          if (!event.ctrlKey){
            break;
          }
          var orig_x_center = xOffset + (pct_shown / 2)
          var orig_y_center = yOffset + (pct_shown / 2)
          var updated_zoom_scale = Math.max(zoomScale - 1, 0)
          setZoomScale(updated_zoom_scale);

          var updated_pct_shown = 1 * Math.pow(SCROLL_SCALE, updated_zoom_scale)
          var updated_x = orig_x_center - (updated_pct_shown/2)
          var updated_y = orig_y_center - (updated_pct_shown/2)
          setXOffset(Math.max(updated_x, 0))
          setYOffset(Math.max(updated_y, 0))

          // Stop zoom action
          event.preventDefault();
          event.stopPropagation();
          break;
            
      }
    };
    window.addEventListener('keydown', handleArrow, { passive: false });
    return () => {
      window.removeEventListener('keydown', handleArrow);
    };
  }, [xOffset, yOffset, zoomScale]);



  console.log("Viewport:", viewportWidth, viewportHeight);
  console.log("ZoomScale:", zoomScale);
  console.log("PCT_SHOWN", pct_shown);
  console.log("xOffset", xOffset)
  console.log("yOffset", yOffset)

  const [modalIsOpen, setIsOpen] = useState(false);

  const [diagramDragStart, setDiagramDragStart] = useState([-1, -1]);
  const [diagramWasDragged, setDiagramWasDragged] = useState(false);

  const updateMDContent = (content) => {
    if (diagramWasDragged) {
      return
    }

    setMDContent(content)

    if (content !== -1){
      setMDWidth(window.innerWidth / 2)
      setViewportWidth(window.innerWidth / 2)
    } else {
      setMDWidth(0)
      setViewportWidth(window.innerWidth)
    }
  } 

  const startDiagramDrag = (e) => {
    const x_start_pct = xOffset + ((e.clientX / viewportWidth) * pct_shown)
    const y_start_pct = yOffset + (((e.clientY - header_height) / viewportHeight) * pct_shown)
    setDiagramWasDragged(false)
    setDiagramDragStart([x_start_pct, y_start_pct])
  }

  const handleDiagramDrag = (e) => {
    // Bail if mouse down event did not init location
    if (diagramDragStart.includes(-1)){
      return
    }
    setDiagramWasDragged(true)

    const x_cur_pct = xOffset + ((e.clientX / viewportWidth) * pct_shown)
    const y_cur_pct = yOffset + (((e.clientY - header_height) / viewportHeight) * pct_shown)

    const x_pct_delta = x_cur_pct - diagramDragStart[0]
    const y_pct_delta = y_cur_pct - diagramDragStart[1]

    const clamp = (x) => {
      return Math.max(Math.min(x, 1.0 - pct_shown), 0)
    }

    setXOffset(clamp(xOffset - x_pct_delta))
    setYOffset(clamp(yOffset - y_pct_delta))
  }

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <div className="App">
      <Header 
        blocksData={blocksData}
        setBlocksData={setBlocksData}
      />
      <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Editor Modal"
           overlayClassName="Overlay"
      >
        <Editor
          closeEditor={closeModal}
          targetID={mdContent}
          blocksData={blocksData}
          setBlocksData={setBlocksData}
        />
      </Modal>

      <div 
        onMouseDown={(e) => startDiagramDrag(e)}
        onMouseMove={(e) => handleDiagramDrag(e)}
        onMouseUp={() => setDiagramDragStart([-1, -1])}
        style={{"width": viewportWidth, "height": "100vh", "overflow": "hidden", "display": "inline", "position": "absolute"}}>
        <BlockSimple
          id={"base"}
          blocks={blocksData['blocks']} 
          parent_size={[viewportWidth / pct_shown, viewportHeight / pct_shown]} 
          x_offset={xOffset} 
          y_offset={yOffset} 
          updateMDContent={updateMDContent}
        />
      </div>
      <Sidebar
        viewportWidth={viewportWidth}
        mdWidth={mdWidth}
        openModal={openModal}
        blocksData={blocksData}
        setBlocksData={setBlocksData}
        targetID={mdContent}
        updateTargetID={updateMDContent}
      />

    </div>
  );
}

export default App;
